module.exports = __webpack_public_path__ + "static/img/v2.0-head.e727b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/v2.0-head.png
// module id = jmh6
// module chunks = 215